import { render, staticRenderFns } from "./FAQ_modal.vue?vue&type=template&id=774c3446"
import script from "./FAQ_modal.vue?vue&type=script&lang=js"
export * from "./FAQ_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports